// You can write more code here
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { getSceneManager } from '@/game/GameComponents/PhaserGame/Managers/SceneManager';
import Assessment from '@/game/GameComponents/PhaserGame/Scenes/Assessment';
import CharacterCreation from '@/game/GameComponents/PhaserGame/Scenes/CharacterCreation/CharacterCreation';
import {
  LevelConfig,
  levelConfigs,
} from '@/game/GameComponents/PhaserGame/tileMapConfig';
import { SceneLaunchContext } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/SceneManagerTypes';
import {
  getAnchorPlugin,
  setFilterModeForAllTextures,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { DEFAULT_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';
import UIBlocker from '@/game/prefabs/GeneralUI/UIBlocker';
import AssessmentIntro from '@/game/scenes/Assessment/AssessmentIntro';
import AssessmentUI from '@/game/scenes/Assessment/AssessmentUI';
import AssessmentWalkthroughPanel from '@/game/scenes/Assessment/AssessmentWalkthroughPanel';
import LevelMap from '@/game/scenes/LevelMap';
import _ from 'lodash';

/* START OF COMPILED CODE */

export default class Preloader extends Phaser.Scene {
  constructor() {
    super('Preloader');

    /* START-USER-CTR-CODE */
    this.tilemapConfig = null;
    /* END-USER-CTR-CODE */
  }

  preload(): void {
    this.load.pack(
      'phaser-game-ui',
      'game_assets/sprites/phaser_game/phaser_game_ui/phaser-game-ui.json',
    );
    this.load.pack(
      'placeholder-assets',
      'game_assets/sprites/phaser_game/placeholder/placeholder-assets.json',
    );
    this.load.pack(
      'phaser-game-audio',
      'game_assets/audio/phaser_game_audio/phaser-game-audio.json',
    );
    this.load.pack('fonts', 'fonts/fonts.json');
    this.load.pack(
      'environmentalAssets',
      'game_assets/animations/environmental/environmentalAssets.json',
    );
    this.load.pack('tiles-generic', 'game_assets/tilemaps/tiles-generic.json');
    this.load.pack(
      'complexions',
      'game_assets/sprites/phaser_game/character_sprites/sprite_assets/complexion/complexions.json',
    );
  }

  editorCreate(): void {
    // uIBlocker
    const uIBlocker = new UIBlocker(this, 0, 0);
    this.add.existing(uIBlocker);

    // mobileView
    const mobileView = this.add.container(0, 0);

    // backdrop_m
    const backdrop_m = this.add.image(336, 244, 'forest-background');
    backdrop_m.scaleX = 3;
    backdrop_m.scaleY = 3;
    mobileView.add(backdrop_m);

    // guardian_m
    const guardian_m = this.add.image(
      304,
      16,
      'Spellcaster_Mentor_1_Forest_GlowNShade',
    );
    guardian_m.scaleX = 0.4;
    guardian_m.scaleY = 0.4;
    guardian_m.setOrigin(0.5, 0);
    mobileView.add(guardian_m);

    // loadingContainer_m
    const loadingContainer_m = this.add.container(336, 356);
    mobileView.add(loadingContainer_m);

    // blackBar_m
    const blackBar_m = this.add.image(-4, 88, '1x1sprite');
    blackBar_m.scaleX = 1024;
    blackBar_m.scaleY = 224;
    blackBar_m.tintTopLeft = 0;
    blackBar_m.tintTopRight = 0;
    blackBar_m.tintBottomLeft = 0;
    blackBar_m.tintBottomRight = 0;
    loadingContainer_m.add(blackBar_m);

    // starPatterns_m
    const starPatterns_m = this.add.image(0, 120, 'star_patterns');
    starPatterns_m.setOrigin(0.5, 1);
    starPatterns_m.alpha = 0.5;
    starPatterns_m.alphaTopLeft = 0.5;
    starPatterns_m.alphaTopRight = 0.5;
    starPatterns_m.alphaBottomLeft = 0.5;
    starPatterns_m.alphaBottomRight = 0.5;
    loadingContainer_m.add(starPatterns_m);

    // backing_m
    const backing_m = this.add.nineslice(
      0,
      -16,
      'Hud3',
      undefined,
      144,
      41,
      12,
      12,
      12,
      12,
    );
    backing_m.scaleX = 4;
    backing_m.scaleY = 4;
    loadingContainer_m.add(backing_m);

    // image_m
    const image_m = this.add.image(0, -36, 'new-spellcaster-logo_png_1');
    image_m.scaleX = 0.25;
    image_m.scaleY = 0.25;
    loadingContainer_m.add(image_m);

    // quipText_m
    const quipText_m = this.add.bitmapText(
      -240,
      28,
      'Aronui',
      "Stealing Guardian Avalanche's Snowboard...",
    );
    quipText_m.setOrigin(0, 0.5);
    quipText_m.tintTopLeft = 5387071;
    quipText_m.tintTopRight = 5387071;
    quipText_m.tintBottomLeft = 5387071;
    quipText_m.tintBottomRight = 5387071;
    quipText_m.text = "Stealing Guardian Avalanche's Snowboard...";
    quipText_m.fontSize = -22;
    loadingContainer_m.add(quipText_m);

    // loadingBar_m
    const loadingBar_m = this.add.container(-288, 88);
    loadingContainer_m.add(loadingBar_m);

    // loading_backing_m
    const loading_backing_m = this.add.image(0, 8, '1x1sprite');
    loading_backing_m.scaleX = 576;
    loading_backing_m.scaleY = 16;
    loading_backing_m.setOrigin(0, 1);
    loading_backing_m.tintTopLeft = 0;
    loading_backing_m.tintTopRight = 0;
    loading_backing_m.tintBottomLeft = 0;
    loading_backing_m.tintBottomRight = 0;
    loadingBar_m.add(loading_backing_m);

    // loading_bar_m
    const loading_bar_m = this.add.image(0, 0, '1x1sprite');
    loading_bar_m.scaleX = 576;
    loading_bar_m.scaleY = 16;
    loading_bar_m.setOrigin(0, 1);
    loading_bar_m.tintTopLeft = 2807978;
    loading_bar_m.tintTopRight = 14807790;
    loading_bar_m.tintBottomLeft = 2807978;
    loading_bar_m.tintBottomRight = 14807790;
    loadingBar_m.add(loading_bar_m);

    // loadingEnd_m
    const loadingEnd_m = this.add.image(576, -8, '1x1sprite');
    loadingEnd_m.scaleX = 2;
    loadingEnd_m.scaleY = 16;
    loadingEnd_m.setOrigin(1, 0.5);
    loadingEnd_m.tintTopLeft = 15130076;
    loadingEnd_m.tintTopRight = 15130076;
    loadingEnd_m.tintBottomLeft = 15130076;
    loadingEnd_m.tintBottomRight = 15130076;
    loadingBar_m.add(loadingEnd_m);

    // desktopView
    const desktopView = this.add.container(0, 0);
    desktopView.visible = false;

    // backdrop
    const backdrop = this.add.image(512, 384, 'forest-background');
    backdrop.scaleX = 5;
    backdrop.scaleY = 5;
    desktopView.add(backdrop);

    // guardian
    const guardian = this.add.image(512, 576, 'npc_mentor_e_portrait');
    guardian.scaleX = 0.6;
    guardian.scaleY = 0.6;
    desktopView.add(guardian);

    // loadingContainer
    const loadingContainer = this.add.container(512, 664);
    desktopView.add(loadingContainer);

    // blackBar
    const blackBar = this.add.image(0, 56, '1x1sprite');
    blackBar.scaleX = 1024;
    blackBar.scaleY = 224;
    blackBar.tintTopLeft = 0;
    blackBar.tintTopRight = 0;
    blackBar.tintBottomLeft = 0;
    blackBar.tintBottomRight = 0;
    loadingContainer.add(blackBar);

    // starPatterns
    const starPatterns = this.add.image(0, 120, 'star_patterns');
    starPatterns.setOrigin(0.5, 1);
    starPatterns.alpha = 0.5;
    starPatterns.alphaTopLeft = 0.5;
    starPatterns.alphaTopRight = 0.5;
    starPatterns.alphaBottomLeft = 0.5;
    starPatterns.alphaBottomRight = 0.5;
    loadingContainer.add(starPatterns);

    // backing
    const backing = this.add.nineslice(
      0,
      -16,
      'Hud3',
      undefined,
      144,
      41,
      12,
      12,
      12,
      12,
    );
    backing.scaleX = 4;
    backing.scaleY = 4;
    loadingContainer.add(backing);

    // image_4
    const image_4 = this.add.image(0, -36, 'new-spellcaster-logo_png_1');
    image_4.scaleX = 0.25;
    image_4.scaleY = 0.25;
    loadingContainer.add(image_4);

    // quipText
    const quipText = this.add.bitmapText(
      -240,
      28,
      'Aronui',
      "Stealing Guardian Avalanche's Snowboard...",
    );
    quipText.setOrigin(0, 0.5);
    quipText.tintTopLeft = 5387071;
    quipText.tintTopRight = 5387071;
    quipText.tintBottomLeft = 5387071;
    quipText.tintBottomRight = 5387071;
    quipText.text = "Stealing Guardian Avalanche's Snowboard...";
    quipText.fontSize = -22;
    loadingContainer.add(quipText);

    // loadingBar
    const loadingBar = this.add.container(-288, 88);
    loadingContainer.add(loadingBar);

    // loading_backing
    const loading_backing = this.add.image(0, 8, '1x1sprite');
    loading_backing.scaleX = 576;
    loading_backing.scaleY = 16;
    loading_backing.setOrigin(0, 1);
    loading_backing.tintTopLeft = 0;
    loading_backing.tintTopRight = 0;
    loading_backing.tintBottomLeft = 0;
    loading_backing.tintBottomRight = 0;
    loadingBar.add(loading_backing);

    // loading_bar
    const loading_bar = this.add.image(0, 0, '1x1sprite');
    loading_bar.scaleX = 576;
    loading_bar.scaleY = 16;
    loading_bar.setOrigin(0, 1);
    loading_bar.tintTopLeft = 2807978;
    loading_bar.tintTopRight = 14807790;
    loading_bar.tintBottomLeft = 2807978;
    loading_bar.tintBottomRight = 14807790;
    loadingBar.add(loading_bar);

    // loadingEnd
    const loadingEnd = this.add.image(576, -8, '1x1sprite');
    loadingEnd.scaleX = 2;
    loadingEnd.scaleY = 16;
    loadingEnd.setOrigin(1, 0.5);
    loadingEnd.tintTopLeft = 15130076;
    loadingEnd.tintTopRight = 15130076;
    loadingEnd.tintBottomLeft = 15130076;
    loadingEnd.tintBottomRight = 15130076;
    loadingBar.add(loadingEnd);

    this.guardian_m = guardian_m;
    this.quipText_m = quipText_m;
    this.loading_bar_m = loading_bar_m;
    this.loadingContainer_m = loadingContainer_m;
    this.mobileView = mobileView;
    this.backdrop = backdrop;
    this.guardian = guardian;
    this.blackBar = blackBar;
    this.quipText = quipText;
    this.loading_bar = loading_bar;
    this.loadingContainer = loadingContainer;
    this.desktopView = desktopView;

    this.events.emit('scene-awake');
  }

  public guardian_m!: Phaser.GameObjects.Image;
  public quipText_m!: Phaser.GameObjects.BitmapText;
  public loading_bar_m!: Phaser.GameObjects.Image;
  private loadingContainer_m!: Phaser.GameObjects.Container;
  public mobileView!: Phaser.GameObjects.Container;
  private backdrop!: Phaser.GameObjects.Image;
  public guardian!: Phaser.GameObjects.Image;
  private blackBar!: Phaser.GameObjects.Image;
  public quipText!: Phaser.GameObjects.BitmapText;
  public loading_bar!: Phaser.GameObjects.Image;
  private loadingContainer!: Phaser.GameObjects.Container;
  public desktopView!: Phaser.GameObjects.Container;

  /* START-USER-CODE */
  tilemapConfig: LevelConfig | null;

  quipInterval?: NodeJS.Timeout = undefined;
  dotInterval?: NodeJS.Timeout = undefined;

  sceneToStart: string = 'LevelMap';
  nextSceneKey: string = '';
  nextSceneType: typeof Phaser.Scene = LevelMap;

  init(data: any) {
    this.sceneToStart = data.sceneToStart ?? 'LevelMap';
    this.nextSceneKey = data.sceneData?.nextSceneKey ?? '';
    this.nextSceneType = data.sceneData?.nextSceneType ?? LevelMap;

    this.editorCreate();

    // Breakpoints.
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this,
      mobileView: this.mobileView,
      desktopView: this.desktopView,
    });

    this.input.setDefaultCursor(`${DEFAULT_CURSOR_PATH}, auto`);

    this.startLoadingQuips();

    this.getResponsiveElements('guardian').forEach(
      (guardian: Phaser.GameObjects.Image) => {
        // This texture was loaded by Boot.ts
        guardian.setTexture('preloader-mentor-portrait');
      },
    );

    // Responsiveness.
    const anchor = getAnchorPlugin(this);
    anchor.add(this.backdrop, {
      centerX: '50%',
      centerY: '50%',
    });
    anchor.add(this.loadingContainer, {
      centerX: '50%',
      centerY: '100%-128',
    });
    anchor.add(this.blackBar, {
      width: '100%',
      height: '0%+160',
    });
    anchor.add(this.guardian, {
      centerX: '50%',
      centerY: '75%',
    });
    anchor.add(this.guardian_m, {
      centerX: '50%',
    });
    anchor.add(this.loadingContainer_m, {
      centerX: '50%',
      centerY: '100%-96',
    });

    // Use the 'progress' event emitted by the LoaderPlugin to update the loading bar
    this.load.on('progress', (progress: number) => {
      // Update the progress bar (our bar is 464px wide, so 100% = 464px)
      this.getResponsiveElements('loading_bar').forEach(
        (loadingBar: Phaser.GameObjects.Image) => {
          loadingBar.setScale(512 * progress, this.loading_bar.scaleY);
        },
      );
    });

    this.load.on(
      'complete',
      () => {
        clearInterval(this.quipInterval);
        clearInterval(this.dotInterval);
        setFilterModeForAllTextures(this, Phaser.Textures.FilterMode.NEAREST);
        let sceneToStartType = Phaser.Scene;
        let launchContext: SceneLaunchContext = {
          type: 'gameplay',
          stopActiveScene: true,
        };
        let nextLaunchContext = {};
        // Ah man this is kinda messy...
        if (this.nextSceneKey === 'Assessment') {
          nextLaunchContext = {
            ...launchContext,
            ...{
              subScenes: [
                { key: 'AssessmentUI', scene: AssessmentUI, type: 'ui' },
                {
                  key: 'AssessmentWalkthroughPanel',
                  scene: AssessmentWalkthroughPanel,
                  type: 'ui',
                },
                {
                  key: 'AssessmentIntro',
                  scene: AssessmentIntro,
                  type: 'ui',
                },
              ],
            },
          };
        }
        switch (this.sceneToStart) {
          case 'CharacterCreation':
            sceneToStartType = CharacterCreation;
            launchContext = {
              ...launchContext,
              type: 'gameplay',
              data: {
                nextSceneKey: this.nextSceneKey,
                nextSceneType: this.nextSceneType,
                nextSceneContext: nextLaunchContext,
              },
            };
            break;
          case 'LevelMap':
            sceneToStartType = LevelMap;
            break;
          case 'Assessment':
            sceneToStartType = Assessment;
            launchContext = {
              ...launchContext,
              type: 'gameplay',
              subScenes: [
                { key: 'AssessmentUI', scene: AssessmentUI, type: 'ui' },
                {
                  key: 'AssessmentWalkthroughPanel',
                  scene: AssessmentWalkthroughPanel,
                  type: 'ui',
                },
                {
                  key: 'AssessmentIntro',
                  scene: AssessmentIntro,
                  type: 'ui',
                },
              ],
            };
            break;
        }
        getSceneManager()?.launchScene(
          this.sceneToStart,
          sceneToStartType,
          launchContext,
        );
      },
      this,
    );
  }

  create() {}

  getResponsiveElements(key: keyof Preloader) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromScene<Preloader>(
      this,
      key,
    );
  }

  loadTilesetAssets() {
    this.computeLevelConfig(); // Get the config for the level
    // Load the tilemap JSON
    this.load.tilemapTiledJSON(
      this.tilemapConfig!.tilemapKey,
      this.tilemapConfig?.tilemapJSON,
    );

    // Preload each tileset specified in the configuration
    this.tilemapConfig?.tilesets.forEach((tileset) => {
      this.load.image(tileset.name, tileset.path);
    });
  }

  computeLevelConfig() {
    const studentLevel = getStudent().level;
    const numberOfMaps = 47; // Total number of unique maps
    const mapIndex = ((studentLevel - 1) % numberOfMaps) + 1; // Compute map index based on level
    this.tilemapConfig = levelConfigs[mapIndex]; // Store the configuration in the instance
  }

  startLoadingQuips() {
    const quips = [
      'Looking up funny words in the dictionary',
      'Polishing potions',
      'Scattering fairy dust',
      "Stealing Guardian Avalanche's snowboard",
      'Joining digraphs',
      'Mining rubies',
      'Choosing new daily activities',
      'Heating up the Phoneme Forge',
      'Silencing letters',
      'Sprinkling synonyms',
    ];

    const randomizedQuips = _.shuffle(quips);

    const quipTexts = this.getResponsiveElements('quipText');
    quipTexts.forEach((quipText: Phaser.GameObjects.BitmapText) => {
      quipText.text = `${randomizedQuips[0]}`;
    });

    let index = 0;
    let numDots = 1;
    let dots = '.';
    this.quipInterval = setInterval(() => {
      index++;
      index %= randomizedQuips.length;
      quipTexts.forEach((quipText: Phaser.GameObjects.BitmapText) => {
        quipText.text = `${randomizedQuips[index]}`;
      });
    }, 4500);

    this.dotInterval = setInterval(() => {
      dots = '';
      for (let i = 0; i < numDots; i++) {
        dots += '.';
      }
      quipTexts.forEach((quipText: Phaser.GameObjects.BitmapText) => {
        quipText.text = `${randomizedQuips[index]}${dots}`;
      });
      numDots++;
      if (numDots > 3) numDots = 1;
    }, 750);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
